module.exports = __webpack_public_path__ + "static/scbz-f8698ad4d195bca8552dbc517fc1cfbb.png";